import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';

import { reducer as formReducer } from 'redux-form/immutable';

import authenticationReducer from './authentication';
import customersReducer from './customers';
import jobsReducer from './jobs';
import tasksReducer from './tasks';
import taskFileConfigsReducer from './taskfileconfigs';
import employeesReducer from './employees';
import jobProfilesReducer from './jobprofiles';
import taskProfilesReducer from './taskprofiles';
import rolesReducer from './roles';
import stagesReducer from './stages';
import staticReducer from './static';
import dialogsReducer from './dialogs';
import billingReducer from './billing';
import itemTypesReducer from './itemtypes';
import labelFormatsReducer from './labelformats';
import activityReducer from './activity';
import exceptionsReducer from './exceptions';
import printersReducer from './printers';
import accountsReducer from './accounts';
import messagesReducer from './messages';
import reportsReducer from './reports';

export default function createReducer() {
  const rootReducer = combineReducers({
    router: routerReducer,
    authentication: authenticationReducer,
    form: formReducer,

    activity: activityReducer,
    billing: billingReducer,
    customers: customersReducer,
    dialogs: dialogsReducer,
    employees: employeesReducer,
    exceptions: exceptionsReducer,
    itemtypes: itemTypesReducer,
    jobprofiles: jobProfilesReducer,
    jobs: jobsReducer,
    labelformats: labelFormatsReducer,
    messages: messagesReducer,
    printers: printersReducer,
    reports: reportsReducer,
    roles: rolesReducer,
    static: staticReducer,
    stages: stagesReducer,
    taskFileConfigs: taskFileConfigsReducer,
    taskprofiles: taskProfilesReducer,
    tasks: tasksReducer,
    accounts: accountsReducer,
  });

  return rootReducer;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js